import { useContext } from "react";
import emptyImage from "../assets/media/todo-empty-state.png";
import { TodosContext } from "../pages/ItemDetail";
const TodoEmpty = () => {
  const { handleModalToggle } = useContext(TodosContext);

  return (
    <div data-cy="todo-empty-state" className="h-[calc(100vh-150px)]">
      <img
        onClick={() => handleModalToggle()}
        src={emptyImage}
        className="cursor-pointer md:w-[541px]"
        alt="todo empty"
      />
    </div>
  );
};

export default TodoEmpty;
